import React, { useState } from 'react';
import {
  Button,
  MaterialIcon,
  Menu,
  Typography,
} from '@qred/components-library';
import { getMarketLanguageLabels } from '~/constants/markets';
import { LanguageIconsType } from '@qred/components-library/dist/lib/components/MaterialIcon/MaterialIcon.types';
import { useClient } from '~/hooks/useClient';
import { useDispatch } from 'react-redux';
import {
  PostHogPageName,
  capturePostHogEvent,
} from '~/store/actions/posthogActions';
import { posthogEventNames } from '~/pages/Dashboard/constants';

export const LanguageItemHeader = () => {
  const { market, language, setLanguage } = useClient();
  const [languageSelectorOpened, setLanguageSelectorOpened] = useState(false);
  const languages = getMarketLanguageLabels(market);
  const selectedLanguageInfo = languages.find((l) => l.value === language);
  const dispatch = useDispatch();
  const languageItems = languages
    .filter(({ value }) => value !== language)
    .map((_language) => (
      <Menu.Item
        key={_language.value}
        onClick={() => setLanguage(_language.value)}
        icon={_language.icon}
      >
        {_language.label.short}
      </Menu.Item>
    ));
  const handleLanguageChange = () => {
    setLanguageSelectorOpened(!languageSelectorOpened);
    dispatch(
      capturePostHogEvent({
        product: PostHogPageName.DASHBOARD,
        eventName: posthogEventNames.CHANAGE_LANGUAGE,
      })
    );
  };
  return (
    <Menu onChange={handleLanguageChange}>
      <Menu.Target>
        <Button size={'md'} variant="tertiary">
          <MaterialIcon src={selectedLanguageInfo?.icon as LanguageIconsType} />
          <Typography ml="sm" mr="sm" weight={500}>
            {selectedLanguageInfo?.label.short}
          </Typography>
          <MaterialIcon
            src={languageSelectorOpened ? 'expand_less' : 'expand_more'}
          />
        </Button>
      </Menu.Target>
      <Menu.Dropdown>{languageItems}</Menu.Dropdown>
    </Menu>
  );
};
